import { Firebase } from './utils/database_common'
import MainRoutes from './components/function/MainRoutes'
import { BrowserRouter } from 'react-router-dom'
import { Toaster } from 'react-hot-toast'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'

import {
  FIREBASE_API_KEY,
  FIREBASE_MESSAGING_SENDER_ID,
  FIREBASE_APP_ID,
  FIREBASE_MEASUREMENT_ID,
} from './env'
import AuthCodeHandler from './components/function/AuthCodeHandler'
import { ModalProvider } from './context/ModalProvider'
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60 * 1000,
      refetchOnWindowFocus: false,
    },
    mutations: {
      retry: 1,
    },
  },
})
export const database = new Firebase({
  apiKey: FIREBASE_API_KEY,
  messagingSenderId: FIREBASE_MESSAGING_SENDER_ID,
  appId: FIREBASE_APP_ID,
  measurementId: FIREBASE_MEASUREMENT_ID,
})
export default function App() {
  database.init()
  return (
    <div className="App">
      <BrowserRouter>
        <QueryClientProvider client={queryClient}>
          <ModalProvider>
            <MainRoutes />
          </ModalProvider>
          <AuthCodeHandler />
          <Toaster position="bottom-right" reverseOrder={false} />
        </QueryClientProvider>
      </BrowserRouter>
    </div>
  )
}
